
namespace TabAurous.OMS {

    @Serenity.Decorators.registerClass()
    export class AddressMasterGrid extends Serenity.EntityGrid<AddressMasterRow, any> {
        protected getColumnsKey() { return 'OMS.AddressMaster'; }
        protected getDialogType() { return AddressMasterDialog; }
        protected getIdProperty() { return AddressMasterRow.idProperty; }
        protected getLocalTextPrefix() { return AddressMasterRow.localTextPrefix; }
        protected getService() { return AddressMasterService.baseUrl; }
        protected getInsertPermission() { return AddressMasterRow.insertPermission; }
        protected getUpdatePermission() { return AddressMasterRow.updatePermission; }
        protected getDeletePermission() { return AddressMasterRow.deletePermission; }
        protected useViewMode() { return true; }

        constructor(container: JQuery) {
            super(container);
            this.slickGrid.setOptions({ rowHeight: 30 });
        }
        private autoSize;

        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            this.autoSize = new Slick.AutoColumnSize(); // *** If you want to make it autoresize when grid is loaded, use: new Slick.AutoColumnSize(true);
            grid.registerPlugin(this.autoSize);
            new Serenity.HeaderFiltersMixin({
                grid: this
            });

            return grid;
        }

        // *** Resizes the columns after changes are made to the grid (ex. Column Picker) *
        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }
    }
}